'use client';

import type { CmsWorkspaceLaunchContext } from '@/cms/workspace/launch-context';
import {
  type CmsWorkspaceLaunchDetail,
  type WorkspacePrefillRequestV1,
  createCmsWorkspaceLaunchId,
  normalizeCmsWorkspaceLaunchDetail,
} from './workspace-prefill-contract';

type CmsWorkspaceLaunchDetailOptions = {
  autoSubmit?: boolean;
  forceAuthSessionRead?: boolean;
  prefill?: WorkspacePrefillRequestV1;
};

function pickDefaultToolId(value: string | null | undefined) {
  return value?.trim() || undefined;
}

export function buildCmsWorkspaceLaunchDetail(
  launchContext: CmsWorkspaceLaunchContext | null | undefined,
  options: CmsWorkspaceLaunchDetailOptions = {}
): CmsWorkspaceLaunchDetail {
  const defaultToolId = pickDefaultToolId(launchContext?.defaultToolId);
  if (!defaultToolId) {
    throw new Error('Workspace launch requires a page-bound Tool ID.');
  }

  const baseDetail = {
    launchId: createCmsWorkspaceLaunchId(),
    autoSubmit: options.autoSubmit === true,
    defaultToolId,
    forceAuthSessionRead: options.forceAuthSessionRead,
  };

  return normalizeCmsWorkspaceLaunchDetail({
    ...baseDetail,
    prefill: options.prefill,
  });
}
